export default __webpack_public_path__ + "static/media/binance-coin.130234e8.png";